export const BINGO_BOARD_TRADES_REQUIRED = 25;

export const BINGO_BOARD_SIZE = 5;

const BINGO_BOARD_INDEXES = Array.from({ length: BINGO_BOARD_SIZE }, (_, i) => i);

export const BINGO_LINES: number[][] = [
	...BINGO_BOARD_INDEXES.map((row) =>
		BINGO_BOARD_INDEXES.map((col) => row * BINGO_BOARD_SIZE + col + 1)
	),
	...BINGO_BOARD_INDEXES.map((col) =>
		BINGO_BOARD_INDEXES.map((row) => row * BINGO_BOARD_SIZE + col + 1)
	),
	BINGO_BOARD_INDEXES.map((i) => i * BINGO_BOARD_SIZE + i + 1),
	BINGO_BOARD_INDEXES.map((i) => i * BINGO_BOARD_SIZE + (BINGO_BOARD_SIZE - 1 - i) + 1),
];

export const BINGO_POINTS_PER_PICK = 1;

export const BINGO_POINTS_PER_LINE = 5;

export const BINGO_POINTS_FIRST_BINGO = 10;
